var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex flex-column align-items-center" },
      [
        _vm.media
          ? _c("img", {
              staticStyle: { "max-width": "100%" },
              attrs: { src: _vm.media.publicUrl, alt: "image" }
            })
          : _c("div", [
              _vm._v(
                "\n      (" +
                  _vm._s(_vm.$t("common.contacts.noImage")) +
                  ")\n    "
              )
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-3" }, [
          _vm.contact && _vm.contact.mediaId
            ? _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  on: { click: _vm.clearPicture }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.contacts.clearPicture")) +
                      "\n      "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              on: {
                click: function($event) {
                  return _vm.$refs.cameraModal.open()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("common.contacts.takePicture")) +
                  "\n      "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("CameraModal", { ref: "cameraModal", on: { apply: _vm.saveMedia } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }